import React from 'react';

class Event extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (
            <div className="Event-details">
                <div className="App-tr first">
                    <p className="Event-details-name">{this.props.name}</p>
                    <p className="Event-details-time">{this.props.time}</p>
                </div>
                <div className="App-tr">
                    <p className="Event-details-description">{this.props.description}</p>
                </div>
            </div>
        )
    }
}

export default Event;